import { AspectRatioValues } from '#components/AspectRatio';
import { lg, md, sm, xl } from '#shared/styles/breakpoints';

export const MAP_BREAKPOINTS = {
	xs: 0,
	sm: sm,
	md: md,
	lg: lg,
	xl: xl,
} as const;

export type MapBreakpointValues = keyof typeof MAP_BREAKPOINTS;

const RATIO_16_9_BREAKPOINTS = new Set<MapBreakpointValues>(['sm', 'xs']);

export function getRatioForBreakpoint(breakpoint: MapBreakpointValues): AspectRatioValues {
	return RATIO_16_9_BREAKPOINTS.has(breakpoint) ? AspectRatioValues.RATIO_16_9 : AspectRatioValues.RATIO_16_4;
}

export function getMapZoomForBreakpoint(breakpoint: MapBreakpointValues): number {
	return RATIO_16_9_BREAKPOINTS.has(breakpoint) ? 11 : 10;
}
